import { SelectGroup } from '@/common'
import { useTranslation } from 'react-i18next'

export default function MonthPicker({
  onChange,
  label,
  value
}: {
  onChange: (value: string) => void
  label?: string
  value: number | null
}) {
  const { t } = useTranslation()
  return (
    <SelectGroup
      label={label}
      options={Array.from({ length: 12 }, (_, i) => ({
        label: t(`common:months.${i + 1}`),
        value: String(i + 1)
      }))}
      value={value ?? ''}
      onChange={evt => onChange(evt.target.value)}
    />
  )
}
